import { ComponentOptionsMixin } from 'vue';


declare module '@vue/runtime-core' {

    interface ComponentCustomProperties {

        isLimitedAccount: boolean;

        remainingReleases: number;
        hasReleasesRemaining: boolean;

        releaseLimit: number;
        resolvedReleaseLimit: number;
        membershipReleaseLimit: number;

        releaseCount: number;
        resolvedReleaseCount: number;
    }
}

export const limitedAccountMixin: ComponentOptionsMixin = {

    computed: {

        isLimitedAccount(): boolean {

            return this.releaseLimit != null || this.remainingReleases != null || this.releaseCount != null;
        },

        hasReleasesRemaining(): boolean {

            if (!this.isLimitedAccount || !this.remainingReleases) {

                return false;
            }

            return this.remainingReleases > 0;
        },

        releaseCount(): number | null {

            return this.$user?.releaseCount ?? null;
        },

        resolvedReleaseCount(): number | null {

            if (this.resolvedReleaseLimit == null || this.remainingReleases == null) {

                return null;
            }

            return this.resolvedReleaseLimit - this.remainingReleases;
        },

        releaseLimit(): number | null {

            return this.$user?.releaseLimit ?? null;
        },

        membershipReleaseLimit(): number | null {

            return this.$user?.activeSubscription?.membership?.releaseLimit ?? null;
        },

        resolvedReleaseLimit(): number | null {

            return Math.max(this.remainingReleases ?? 0, this.membershipReleaseLimit ?? 0);
        },

        remainingReleases(): number | null {

            return this.$user?.remainingReleases ?? null;
        }
    },
};